<template>
  <section class="section-filter">
    <div>
      <div class="row filter-title">
        <div class="col-6 pl-0">
          <div class="title-title">
            <span><router-link :to="{name: 'ebook'}">Sách điện tử</router-link></span>
            <i v-if="bookTypeModel!=null" class="fa fa-angle-right"></i>
            <router-link v-if="bookTypeModel!=null"  :to="{ name: 'ebook-type', params: {id: bookTypeModel.bookTypeId} }" title="">{{bookTypeModel.name}}</router-link>
            <i v-if="bookClassModel!=null" class="fa fa-angle-right"></i>
            <router-link v-if="bookClassModel!=null" :to="{ name: 'ebook-class', params: {id: bookClassModel.classId} }" title="">{{bookClassModel.name}}</router-link>
          </div>
        </div>
        <div class="col-6 pr-0">
          <div class="btn-filter">
            <a id="btn-filter" title="" @click="toggleFilter"><img src="@/assets/img/HS_de_thi.png" alt=""> Bộ lọc</a>
          </div>
        </div>
      </div>
      <div class="filters" id="filters" v-if="isFilter">
        <div class="filter" v-show="showBookType">
          <div class="row">
            <div class="col-12">
              <div class="title" ><span id="filter1">Loại sách</span></div>
            </div>
          </div>
          <div class="row checks" id="checks1">            
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
              <label class="check">
                <input type="checkbox" @change="allBookType" v-model="allBookTypes">
                <span class="_title">Tất cả</span>
                <span class="checkmark"></span>
              </label>
            </div>
            <div v-for="bType in filters.bookTypes" class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
              <label class="check">
                <input type="checkbox" v-model="bType.selected" v-bind:id="bType.bookTypeId" @click="changeBookType(bType.bookTypeId)">
                <span class="_title">{{bType.name}}</span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="filter" v-show="showLevel">
          <div class="row">
            <div class="col-12">
              <div class="title" ><span id="filter2">Chương trình</span></div>
            </div>
          </div>
          <div class="row checks" id="checks2">
            <div class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
              <label class="check">
                <input type="checkbox" @click="allLevel" v-model="allLevels">
                <span class="_title">Tất cả</span>
                <span class="checkmark"></span>
              </label>
            </div>
            <div v-for="item in filters.bookLevels" class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
              <label class="check">
                <input type="checkbox" v-model="item.selected" v-bind:id="item.bookLevelId" @click="changeLevel(item.bookLevelId)">
                <span class="_title">{{item.name}}</span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="filter" v-show="showClass">
          <div class="row">
            <div class="col-12">
              <div class="title" ><span id="filter2">Lớp học</span></div>
            </div>
          </div>
          <div class="row checks" id="checks2">
             <div v-for="item in filters.classes" class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
              <label class="check">
                <input type="checkbox" v-model="item.selected" v-bind:id="item.classId" @click="changeClass(item.classId)">
                <span class="_title">{{item.name}}</span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="filter" v-show="showSubject">
          <div class="row">
            <div class="col-12">
              <div class="title" ><span id="filter3">Môn học</span></div>
            </div>
          </div>
          <div class="row checks" id="checks3">
            <div v-for="item in filters.subjects" class="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6">
              <label class="check">
                <input type="checkbox" v-model="item.selected" v-bind:id="item.subjectId" @click="changeSubject(item.subjectId)">
                <span class="_title">{{item.name}}</span>
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="btns-filter">
          <div class="row">
            <div class="col-12">
              <ul class="nav">
                <li class="nav-item">
                  <a class="nav-link btn-reset" @click="resetFilter" >Reset</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link active" href="#" @click="submitFilter">Lọc</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import {mapGetters, mapActions} from 'vuex';
  import {STORE_KEY} from '../_store/constants'
  import store from '../_store'
export default {
  name: 'EBookFilter',
  data() {
    return {
      isFilter: false,
      bookTypes: [
        // {id: 1, name: "Sách Giáo Khoa", selected: false},
        // {id: 2, name: "Sách Bổ Trợ", selected: false},
      ],
      allBookTypes: false,
      levels: [
        // {id: 1, name: "Cơ bản", selected: false},
        // {id: 2, name: "Nâng cao", selected: false},
      ],
      allLevels: false,
      classes: [
        // {id: 1, name: "Lớp 01", selected: false},
        // {id: 2, name: "Lớp 02", selected: false},
        // {id: 3, name: "Lớp 03", selected: false},
        // {id: 4, name: "Lớp 04", selected: false},
        // {id: 5, name: "Lớp 05", selected: false},
        // {id: 6, name: "Lớp 06", selected: false},
        // {id: 7, name: "Lớp 07", selected: false},
        // {id: 8, name: "Lớp 08", selected: false},
        // {id: 9, name: "Lớp 09", selected: false},
        // {id: 10, name: "Lớp 10", selected: false},
        // {id: 11, name: "Lớp 11", selected: false},
        // {id: 12, name: "Lớp 12", selected: false},
      ],
      isAllClasses: false,
      subjects: [
        // {id: "toán", name: "Toán học", selected: false},
        // {id: "đại số", name: "Đại số", selected: false},
        // {id: "giải tích", name: "Giải tích", selected: false},
        // {id: "hình học", name: "Hình học", selected: false},
        // {id: "tiếng việt", name: "Tiếng Việt", selected: false},
        // {id: "văn", name: "Ngữ văn", selected: false},
        // {id: "ngoại ngữ", name: "Ngoại ngữ", selected: false},
        // {id: "tự nhiên và xã hội", name: "Tự nhiên và xã hội", selected: false},
        // {id: "khoa học", name: "Khoa học", selected: false},
        // {id: "vật lý", name: "Vật lý", selected: false},
        // {id: "hóa học", name: "Hóa học", selected: false},
        // {id: "sinh học", name: "Sinh học", selected: false},
        // {id: "lịch sử và địa lí", name: "Lịch sử và Địa lí", selected: false},
        // {id: "lịch sử", name: "Lịch sử", selected: false},
        // {id: "địa lí", name: "Địa lí", selected: false},
        // {id: "đạo đức", name: "Đạo đức", selected: false},
        // {id: "giáo dục công dân", name: "Giáo dục công dân", selected: false},
        // {id: "công nghệ", name: "Công nghệ", selected: false},
        // {id: "tin học", name: "Tin học", selected: false},
        // {id: "âm nhạc, mỹ thuật", name: "Âm nhạc, Mĩ thuật", selected: false},
        // {id: "giáo dục thể chất", name: "Giáo dục thể chất", selected: false},
        // {id: "quốc phòng an ninh", name: "Quốc phòng an ninh", selected: false},
        // {id: "khác", name: "Khác", selected: false}
      ],
      allSubjects: false,
      filterObj:{
        book_type: this.bookType,
        classes: this.bookClass
      }
    }
  },
  props:{
    showBookType: true,
    showClass: true,
    showLevel: true,
    showSubject: true,
    bookType: null,
    bookClass: null,
    bookTypeModel: null,
    bookClassModel:null
  },
  computed: {
    ...mapGetters({
      //filterObj: STORE_KEY + '/ebooksFilter',
      //allClasses: STORE_KEY + '/allClasses',
      filters: STORE_KEY + '/filters',
    }),
  },
//  created(){
//
//    this.classes=[]
//    for (var i = 0; i < this.allClasses.length; i ) {
//      this.classes.push({id: this.allClasses[i].id,name:this.allClasses[i].name,selected:false});
//    }
//  },
  mounted(){
    //this.$store.dispatch(STORE_KEY + '/getAllClasses');
    this.$store.dispatch(STORE_KEY + '/getFilters');
  },
  methods: {
    toggleFilter() {
      this.isFilter = !this.isFilter
    },
    resetFilter(){
//      this.$store.dispatch(STORE_KEY + '/getEBooksFilter',{
//        book_type: [],
//        classes: [],
//        levels: [],
//        subjects : []
//      });

      this.filterObj.book_type = [];
      this.filterObj.levels = [];
      this.filterObj.classes = [];
      this.filterObj.subjects = [];

      this.filters.bookTypes.map((obj, index, objects) => {
        obj.selected = false;
    });
      this.filters.classes.map((obj, index, objects) => {
        obj.selected = false;
    });

      this.filters.bookLevels.map((obj, index, objects) => {
        obj.selected = false;
    });

      this.filters.subjects.map((obj, index, objects) => {
        obj.selected = false;
    });

      this.isFilter = false;
      //this.$store.dispatch(STORE_KEY + '/getEBooksFilter',this.filterObj);
      //this.$store.dispatch(STORE_KEY + '/getEBooks',this.filterObj);
      this.$emit('filterBooks', this.filterObj)
    },
    submitFilter() {
      this.isFilter = !this.isFilter
      //this.$store.dispatch(STORE_KEY + '/getEBooksFilter',this.filterObj);
      //this.$store.dispatch(STORE_KEY + '/getEBooks',this.filterObj);
 // console.log("submitFilter")
 //      console.log(this.filterObj)
      this.$emit('filterBooks', this.filterObj)
    },
    filterType(type){
      this.filterObj.book_type = [1];
    },
    allBookType(){
      this.filterObj.book_type = [];

              this.bookTypes.forEach((btype, index) => {
                if(!this.allBookTypes){
                    this.filterObj.book_type.push(btype.id);
                    }
                    btype.selected=!this.allBookTypes;
              });
                this.allBookTypes=!this.allBookTypes;
    },
    changeBookType(id){
      this.allBookTypes=false;
      this.filterObj.book_type = [];
      this.filters.bookTypes.forEach((btype, index) => {
        if(btype.bookTypeId == id){
          btype.selected=!btype.selected;
        }
        if(btype.selected){
          this.filterObj.book_type.push(btype.bookTypeId);
        }
      });
    },
    allLevel(){
      this.filterObj.levels = [];

              this.filters.bookLevels.forEach((item, index) => {
                  if(!this.allLevels){
                    this.filterObj.levels.push(item.id);
                    }
                    item.selected=!this.allLevels;
              });
                this.allLevels=!this.allLevels;
    },
    changeLevel(id){
      this.allLevels=false;
      this.filterObj.levels = [];
      this.filters.bookLevels.forEach((item, index) => {
        if(item.bookLevelId == id){
          item.selected=!item.selected;
        }
        if(item.selected){
          this.filterObj.levels.push(item.bookLevelId);
        }
      });
    },
    changeClass(id){
      this.filterObj.classes = [];
      this.filters.classes.forEach((item, index) => {
        if(item.classId == id){
          item.selected=!item.selected;
        }
        if(item.selected){
          this.filterObj.classes.push(item.classId);
        }
      });
    },
    changeSubject(id){
      this.filterObj.subjects = [];
      this.filters.subjects.forEach((item, index) => {
        if(item.subjectId == id){
          item.selected=!item.selected;
        }
        if(item.selected){
          this.filterObj.subjects.push(item.subjectId);
        }
      });
    }
  }
}
</script>